/**
 * TinyMCE 6.x Configuration for Mobile
 */
import CommunityService from '../services/community'

let isUploading = false
const MAX_UPLOAD_FILES = 12;
let uploadedFileCount = 0;

function setUploadingState(uploading, editor) {
  isUploading = uploading

  if (editor) {
    const container = editor.getContainer()
    if (container) {
      const toolbar = container.querySelector('.tox-toolbar')
      if (toolbar) {
        toolbar.style.pointerEvents = uploading ? 'none' : ''
        toolbar.style.opacity = uploading ? '0.5' : ''
      }
    }
  }
}

/**
 * File picker callback for images and videos
 */
const isValidUrl = (url) => {
  try {
    const urlObj = new URL(url)
    return ['http:', 'https:'].includes(urlObj.protocol)
  } catch {
    return false
  }
}

const isS3Url = (url) => {
  if (!isValidUrl(url)) return false

  const s3Pattern = /^https?:\/\/([a-z0-9.-]+\.)?(s3[.-][a-z0-9-]*\.)?amazonaws\.com/i
  return s3Pattern.test(url)
}

const isValidImageUrl = (url) => {
  if (url && url.indexOf('/') === 0) {
    const isEmoticon = url.indexOf('/editor/') === 0 || url.indexOf('/cheditor/') === 0
    const isDataPath = url.indexOf('/data/') === 0
    const isImgPath = url.indexOf('/img/') === 0

    if (isEmoticon || isDataPath || isImgPath) {
      const imageExtensions = /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i
      return imageExtensions.test(url)
    }
    return false
  }

  if (!isValidUrl(url)) return false

  if (isS3Url(url)) return true

  const imageExtensions = /\.(jpg|jpeg|png|gif|webp|svg)(\?.*)?$/i
  return imageExtensions.test(url)
}

const isValidVideoUrl = (url) => {
  if (!isValidUrl(url)) return false

  if (isS3Url(url)) return true

  const videoExtensions = /\.(mp4|webm|ogg|ogv|avi|mov|wmv|flv|mkv|m4v|3gp)(\?.*)?$/i
  return videoExtensions.test(url)
}

/**
 * Convert YouTube URL to iframe embed code
 * @param {string} url - YouTube URL
 * @returns {string|null} - Iframe embed code or null if not a YouTube URL
 */
const convertYouTubeUrlToIframe = (url) => {
  if (!url || typeof url !== 'string') return null

  // Check if already an iframe
  if (url.trim().indexOf('<iframe') === 0) {
    return null // Already an iframe, let existing logic handle it
  }

  // Normalize URL - remove query params and trailing slashes for matching
  const normalizedUrl = url.trim()

  let videoId = null
  let isShorts = false

  // Check for YouTube Shorts FIRST (must check before regular YouTube URLs)
  // Pattern: youtube.com/shorts/VIDEO_ID (with optional www, http/https, and query params)
  const shortsPattern = /(?:https?:\/\/)?(?:www\.)?youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})(?:\?.*)?/i
  const shortsMatch = normalizedUrl.match(shortsPattern)
  if (shortsMatch && shortsMatch[1]) {
    videoId = shortsMatch[1]
    isShorts = true
  } else {
    // Check for regular YouTube URLs (watch, embed, youtu.be, etc.)
    const regularPatterns = [
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/i,
      /(?:https?:\/\/)?(?:www\.)?youtu\.be\/([a-zA-Z0-9_-]{11})/i,
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/i,
      /(?:https?:\/\/)?(?:www\.)?youtube\.com\/v\/([a-zA-Z0-9_-]{11})/i,
      /(?:https?:\/\/)?(?:www\.)?m\.youtube\.com\/watch\?v=([a-zA-Z0-9_-]{11})/i
    ]

    for (const pattern of regularPatterns) {
      const match = normalizedUrl.match(pattern)
      if (match && match[1]) {
        videoId = match[1]
        isShorts = false
        break
      }
    }
  }

  if (!videoId) return null

  // Determine dimensions based on video type
  const width = isShorts ? 449 : 1278
  const height = isShorts ? 799 : 719

  // Create iframe embed code with data attribute to preserve type info
  const embedUrl = `https://www.youtube.com/embed/${videoId}`
  return `<iframe width="${width}" height="${height}" src="${embedUrl}" title="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen data-youtube-shorts="${isShorts}" data-youtube-type="${isShorts ? 'shorts' : 'regular'}"></iframe>`
}

// export const createFilePickerCallback = (recaptchaVerify) => {
//   return function (callback, value, meta) {
//     if (isUploading) {
//       return
//     }
//
//     const input = document.createElement('input')
//     input.setAttribute('type', 'file')
//
//     if (meta.filetype === 'image') {
//       input.setAttribute('accept', 'image/jpeg,image/jpg,image/png,image/gif,image/bmp')
//     } else if (meta.filetype === 'media') {
//       input.setAttribute('accept', 'video/mp4')
//     }
//
//     input.onchange = async function () {
//       const file = this.files[0]
//
//       // Validate file type
//       const fileName = file.name.toLowerCase()
//       const fileExt = fileName.substring(fileName.lastIndexOf('.') + 1)
//
//       if (meta.filetype === 'image') {
//         const allowedImageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp']
//         if (!allowedImageExts.includes(fileExt)) {
//           alert('이미지 파일만 업로드 가능합니다.')
//           return
//         }
//       } else if (meta.filetype === 'media') {
//         if (fileExt !== 'mp4') {
//           alert('Mp4 파일만 업로드 가능합니다.')
//           return
//         }
//       }
//
//       const maxSize = 30 * 1024 * 1024 // 30MB for both images and videos
//       if (file.size > maxSize) {
//         alert('파일 크기가 너무 큽니다. 최대 ' + maxSize / (1024 * 1024) + 'MB까지 업로드 가능합니다.')
//         return
//       }
//
//       const uploadText = meta.filetype === 'image' ? '이미지' : '비디오'
//       const editor = window.tinymce?.activeEditor || tinymce.activeEditor
//
//       setUploadingState(true, editor)
//       if (editor) {
//         editor.setProgressState(true)
//         const existingOverlay = document.querySelector('.tox-dialog-loading-overlay')
//         if (existingOverlay) {
//           existingOverlay.remove()
//         }
//
//         if (!document.querySelector('#tinymce-loading-css')) {
//           const style = document.createElement('style')
//           style.id = 'tinymce-loading-css'
//           style.textContent = `
//             .tox-dialog-loading-overlay {
//               position: fixed !important;
//               top: 0 !important;
//               left: 0 !important;
//               right: 0 !important;
//               bottom: 0 !important;
//               background: rgba(255, 255, 255, 0.85) !important;
//               z-index: 99999 !important;
//               display: none !important;
//             }
//             .tox-dialog-loading-overlay.show {
//               display: flex !important;
//               align-items: center !important;
//               justify-content: center !important;
//             }
//             .tox-dialog-loading-spinner {
//               color: #222f3e !important;
//               font-size: 16px !important;
//               position: relative !important;
//               text-indent: -9999em !important;
//               transform: translateZ(0) !important;
//               animation-delay: -0.16s !important;
//               border-radius: 50% !important;
//               width: 1em !important;
//               height: 1em !important;
//               animation-fill-mode: both !important;
//               animation: bblFadInOut 1.8s infinite ease-in-out !important;
//             }
//             .tox-dialog-loading-spinner:before, .tox-dialog-loading-spinner:after {
//               content: '' !important;
//               position: absolute !important;
//               top: 0 !important;
//               border-radius: 50% !important;
//               width: 1em !important;
//               height: 1em !important;
//               animation-fill-mode: both !important;
//               animation: bblFadInOut 1.8s infinite ease-in-out !important;
//             }
//             .tox-dialog-loading-spinner:before {
//               left: -1.5em !important;
//               animation-delay: -0.32s !important;
//             }
//             .tox-dialog-loading-spinner:after {
//               left: 1.5em !important;
//             }
//             .tox.tox-textfield,
//             .tox .tox-textfield,
//             .tox.tox-textarea,
//             .tox .tox-textarea,
//             .tox-dialog .tox-textfield,
//             .tox-dialog input[type="text"],
//             .tox-dialog input[type="url"],
//             .tox-dialog input.tox-textfield,
//             .tox-dialog textarea,
//             input.tox-textfield {
//               border-color: #aaa !important;
//             }
//             @keyframes bblFadInOut {
//               0%, 80%, 100% { box-shadow: 0 1em 0 -0.3em }
//               40% { box-shadow: 0 1em 0 0 }
//             }
//           `
//           document.head.appendChild(style)
//         }
//
//         const overlay = document.createElement('div')
//         overlay.className = 'tox-dialog-loading-overlay show'
//         overlay.innerHTML = '<div class="tox-dialog-loading-spinner"></div>'
//
//         // Add to body
//         document.body.appendChild(overlay)
//         console.log('Loading overlay added:', overlay)
//
//         setTimeout(() => {
//           const existingOverlay2 = document.querySelector('.tox-dialog-loading-overlay')
//           if (!existingOverlay2) {
//             const overlay2 = document.createElement('div')
//             overlay2.className = 'tox-dialog-loading-overlay show'
//             overlay2.innerHTML = '<div class="tox-dialog-loading-spinner"></div>'
//             document.body.appendChild(overlay2)
//           }
//         }, 200)
//       }
//
//       // Set timeout to hide loading after 30 seconds
//       const recaptchaTimeout = setTimeout(() => {
//         console.log('reCAPTCHA timeout')
//         setUploadingState(false, editor)
//         if (editor) {
//           editor.setProgressState(false)
//           setTimeout(() => {
//             const overlay = document.querySelector('.tox-dialog-loading-overlay')
//             if (overlay) {
//               overlay.remove()
//             }
//           }, 100)
//         }
//       }, 30000)
//
//       // Add click outside listener to detect when popup is dismissed
//       const recaptchaClickOutsideHandler = (e) => {
//         // Check if click is outside reCAPTCHA iframe
//         if (
//           !e.target.closest('iframe[src*="recaptcha"]') &&
//           !e.target.closest('.g-recaptcha') &&
//           !e.target.closest('#recaptcha-loading') &&
//           !e.target.closest('.tox-dialog-loading-overlay')
//         ) {
//           console.log('reCAPTCHA popup dismissed by clicking outside')
//           clearTimeout(recaptchaTimeout)
//           setUploadingState(false, editor)
//           if (editor) {
//             editor.setProgressState(false)
//             setTimeout(() => {
//               const overlay = document.querySelector('.tox-dialog-loading-overlay')
//               if (overlay) {
//                 overlay.remove()
//               }
//             }, 100)
//           }
//           document.removeEventListener('click', recaptchaClickOutsideHandler)
//           // Just return without error - user cancelled
//           return
//         }
//       }
//
//       // Add listener after a short delay to avoid immediate trigger
//       setTimeout(() => {
//         document.addEventListener('click', recaptchaClickOutsideHandler)
//       }, 100)
//
//       try {
//         // Get reCAPTCHA token
//         const token = await recaptchaVerify()
//         if (!token) {
//           throw new Error('reCAPTCHA verification failed')
//         }
//
//         // Clear timeout and remove listener on success
//         clearTimeout(recaptchaTimeout)
//         document.removeEventListener('click', recaptchaClickOutsideHandler)
//
//         const result = await CommunityService.uploadFile(file, token)
//
//         setUploadingState(false, editor)
//         if (editor) {
//           editor.setProgressState(false)
//           setTimeout(() => {
//             const overlay = document.querySelector('.tox-dialog-loading-overlay')
//             if (overlay) {
//               overlay.remove()
//             }
//           }, 100)
//         }
//
//         if (result && result.code === 200 && result.data && result.data.url) {
//           if (meta.filetype === 'media') {
//             const videoHtml = `
//               <p>
//                 <video controls preload="metadata" style="display: block; margin: 0;">
//                   <source src="${result.data.url}" type="video/mp4" />
//                   Your browser does not support the video tag.
//                 </video>
//               </p>`
//
//             editor.insertContent(videoHtml)
//
//             if (editor.windowManager) {
//               editor.windowManager.close()
//             }
//           } else if (meta.filetype === 'image') {
//             callback(result.data.url, {
//               title: result.data.name,
//               width: null,
//               height: null,
//             })
//           }
//         } else {
//           alert(result.message || uploadText + ' 업로드에 실패했습니다.')
//         }
//       } catch (error) {
//         // Clear timeout and remove listener on error
//         clearTimeout(recaptchaTimeout)
//         document.removeEventListener('click', recaptchaClickOutsideHandler)
//
//         setUploadingState(false, editor)
//         if (editor) {
//           editor.setProgressState(false)
//           setTimeout(() => {
//             const overlay = document.querySelector('.tox-dialog-loading-overlay')
//             if (overlay) {
//               overlay.remove()
//             }
//           }, 100)
//         }
//         alert(uploadText + ' 업로드 중 오류가 발생했습니다: ' + error.message)
//       }
//     }
//
//     input.click()
//   }
// }
export const createFilePickerCallback = (recaptchaVerify) => {
  return function (callback, value, meta) {
    if (isUploading) return

    if (uploadedFileCount >= MAX_UPLOAD_FILES) {
      alert(`You can upload up to ${MAX_UPLOAD_FILES} files only.`);
      return;
    }

    const input = document.createElement('input')
    input.type = 'file'
    input.multiple = true

    if (meta.filetype === 'image') {
      input.accept = 'image/jpeg,image/jpg,image/png,image/gif,image/bmp'
    } else if (meta.filetype === 'media') {
      input.accept = 'video/mp4'
    }

    input.onchange = () => {
      const files = Array.from(input.files)
      const remaining = MAX_UPLOAD_FILES - uploadedFileCount;
      if (files.length > remaining) {
        alert(`You can upload only ${remaining} more file(s).`);
        return;
      }
      const editor = tinymce.activeEditor

      /* ================= OVERLAY HELPERS ================= */

      const ensureOverlayCss = () => {
        if (document.querySelector('#tinymce-loading-css')) return

        const style = document.createElement('style')
        style.id = 'tinymce-loading-css'
        style.textContent = `
          .tox-dialog-loading-overlay {
            position: fixed;
            inset: 0;
            background: rgba(255,255,255,.85);
            z-index: 99999;
            display: none;
            align-items: center;
            justify-content: center;
          }
          .tox-dialog-loading-overlay.show {
            display: flex;
          }
          .tox-dialog-loading-spinner {
            width: 1em;
            height: 1em;
            border-radius: 50%;
            animation: bblFadInOut 1.8s infinite ease-in-out;
          }
          .tox-dialog-loading-spinner:before,
          .tox-dialog-loading-spinner:after {
            content: '';
            position: absolute;
            width: 1em;
            height: 1em;
            border-radius: 50%;
            animation: bblFadInOut 1.8s infinite ease-in-out;
          }
          .tox-dialog-loading-spinner:before {
            left: -1.5em;
            animation-delay: -.32s;
          }
          .tox-dialog-loading-spinner:after {
            left: 1.5em;
          }
          @keyframes bblFadInOut {
            0%,80%,100% { box-shadow: 0 1em 0 -0.3em }
            40% { box-shadow: 0 1em 0 0 }
          }
        `
        document.head.appendChild(style)
      }

      const showOverlay = () => {
        ensureOverlayCss()

        let overlay = document.querySelector('.tox-dialog-loading-overlay')
        if (!overlay) {
          overlay = document.createElement('div')
          overlay.className = 'tox-dialog-loading-overlay show'
          overlay.innerHTML = `<div class="tox-dialog-loading-spinner"></div>`
          document.body.appendChild(overlay)
        } else {
          overlay.classList.add('show')
        }
      }

      const hideOverlay = () => {
        const overlay = document.querySelector('.tox-dialog-loading-overlay')
        overlay?.remove()
      }

      /* ================= UPLOAD LOGIC ================= */

      const uploadNext = async () => {
        if (files.length === 0) {
          editor?.windowManager?.close()
          return
        }

        // Check if user selected more than MAX files in THIS batch
        if (files.length > MAX_UPLOAD_FILES) {
          alert(`You can upload up to ${MAX_UPLOAD_FILES} files at once.`);
          files.length = MAX_UPLOAD_FILES; // Truncate to max
        }

        // Validate all files first
        for (const file of files) {
          const ext = file.name.toLowerCase().split('.').pop()
          // TYPE CHECK
          if (
            (meta.filetype === 'image' && !['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext)) ||
            (meta.filetype === 'media' && ext !== 'mp4')
          ) {
            alert('파일 형식이 올바르지 않습니다.')
            // validation continues...
          }
          // SIZE CHECK
          if (file.size > 30 * 1024 * 1024) {
            // ...
          }
        }

        const validFiles = files.filter(file => {
          const ext = file.name.toLowerCase().split('.').pop()
          if (meta.filetype === 'image' && !['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext)) {
            alert(file.name + ': 파일 형식이 올바르지 않습니다.')
            return false
          }
          if (meta.filetype === 'media' && ext !== 'mp4') {
            alert(file.name + ': Mp4 파일만 업로드 가능합니다.')
            return false
          }
          if (file.size > 30 * 1024 * 1024) {
            alert(file.name + ': 파일 크기가 너무 큽니다.')
            return false
          }
          return true
        })

        if (validFiles.length === 0) {
          editor?.windowManager?.close()
          return
        }

        try {
          setUploadingState(true, editor)
          editor?.setProgressState(true)
          showOverlay()

          const token = await recaptchaVerify()
          if (!token) throw new Error('reCAPTCHA failed')

          // Use the new batch upload method
          const result = await CommunityService.uploadFiles(validFiles, token)

          if (result?.code === 200 && result?.data?.files?.length) {
            result.data.files.forEach(file => {
              // uploadedFileCount++; // No longer tracking global count for limit
              if (file.type && file.type.startsWith('video')) {
                editor.insertContent(`
                        <p>
                          <video controls preload="metadata" style="display:block;margin:0;">
                            <source src="${file.url}" type="video/mp4">
                          </video>
                        </p>
                      `)
              } else {
                editor.insertContent(`<img src="${file.url}" alt="" />`)
              }
            })

            if (editor.windowManager) {
              editor.windowManager.close()
            }

          } else {
            alert(result?.data?.message || result?.message || '업로드 실패')
          }
        } catch (err) {
          if (err !== 'RECAPTCHA_DISMISSED') {
            alert(err.message || err)
          }
        } finally {
          setUploadingState(false, editor)
          editor?.setProgressState(false)
          hideOverlay()
          // No recursion needed for batch
        }
      }

      uploadNext()
    }

    input.click()
  }
}
/**
 * Images upload handler
 */
export const createImagesUploadHandler = (recaptchaVerify) => {
  return function (blobInfo, progress) {
    return new Promise(async (resolve, reject) => {
      // Validate file type
      const fileName = blobInfo.filename().toLowerCase()
      const fileExt = fileName.substring(fileName.lastIndexOf('.') + 1)
      const allowedImageExts = ['jpg', 'jpeg', 'png', 'gif', 'bmp']

      if (uploadedFileCount >= MAX_UPLOAD_FILES) {
        alert(`You can upload up to ${MAX_UPLOAD_FILES} files only.`);
        resolve('')
        return;
      }

      if (!allowedImageExts.includes(fileExt)) {
        alert('이미지 파일만 업로드 가능합니다.')
        resolve('')
        return
      }

      setUploadingState(true, window.tinymce?.activeEditor)

      // Set timeout to hide loading after 30 seconds
      const recaptchaTimeout = setTimeout(() => {
        console.log('reCAPTCHA timeout')
        setUploadingState(false, window.tinymce?.activeEditor)
        reject(new Error('reCAPTCHA timeout'))
      }, 30000)

      // Add click outside listener to detect when popup is dismissed
      const recaptchaClickOutsideHandler = (e) => {
        // Check if click is outside reCAPTCHA iframe
        if (
          !e.target.closest('iframe[src*="recaptcha"]') &&
          !e.target.closest('.g-recaptcha') &&
          !e.target.closest('#recaptcha-loading') &&
          !e.target.closest('.tox-dialog-loading-overlay')
        ) {
          console.log('reCAPTCHA popup dismissed by clicking outside')
          clearTimeout(recaptchaTimeout)
          setUploadingState(false, window.tinymce?.activeEditor)
          document.removeEventListener('click', recaptchaClickOutsideHandler)
          // Resolve with empty string to indicate user cancelled
          resolve('')
        }
      }

      // Add listener after a short delay to avoid immediate trigger
      setTimeout(() => {
        document.addEventListener('click', recaptchaClickOutsideHandler)
      }, 100)

      try {
        const token = await recaptchaVerify()
        if (!token) {
          // User cancelled or verification failed
          setUploadingState(false, window.tinymce?.activeEditor)
          // Resolve with empty string to indicate user cancelled
          resolve('')
          return
        }

        // Clear timeout and remove listener on success
        clearTimeout(recaptchaTimeout)
        document.removeEventListener('click', recaptchaClickOutsideHandler)

        const url = await CommunityService.uploadFileWithProgress(blobInfo.blob(), blobInfo.filename(), token, progress)

        setUploadingState(false, window.tinymce?.activeEditor)
        resolve(url)
      } catch (error) {
        // Clear timeout and remove listener on error
        clearTimeout(recaptchaTimeout)
        document.removeEventListener('click', recaptchaClickOutsideHandler)

        setUploadingState(false, window.tinymce?.activeEditor)
        reject(error)
      }
    })
  }
}

/**
 * TinyMCE 6 Configuration for Mobile
 */

/**
 * Inject TinyMCE global styles
 */
export const injectTinyMCEStyles = () => {
  if (typeof document === 'undefined') return

  // Check if already injected
  if (document.getElementById('tinymce-global-styles')) return

  const style = document.createElement('style')
  style.id = 'tinymce-global-styles'
  style.textContent = `
    /* TinyMCE Input Border Color Override */
    .tox-tinymce input.tox-textfield,
    .tox-dialog input.tox-textfield,
    .tox-dialog input[type="url"],
    .tox-dialog input[type="text"],
    .tox-dialog textarea,
    input.tox-textfield[type="url"],
    .tox .tox-form__group input.tox-textfield {
      border-color: #aaa !important;
    }
  `
  document.head.appendChild(style)
}

export const closeAllTinyMCEMenus = () => {
  if (typeof document === 'undefined') return
  document.body.classList.add('clicked-outside')

  const selectors = ['.tox-pop', '.tox-collection', '.tox-menu']
  selectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      el.classList.remove('tox-pop--opened', 'tox-collection--opened', 'tox-menu--opened')
      el.setAttribute('style', 'display:none !important; visibility:hidden !important;')
    })
  })

  setTimeout(() => document.body.classList.remove('clicked-outside'), 50)
}
export const getTinyMCEConfig = (recaptchaVerify) => {
  return {
    license_key: 'gpl',
    promotion: false,
    base_url: '/tinymce-8.1.2/js/tinymce',

    language: 'ko_KR',

    min_height: 600,

    plugins: [
      'advlist',
      'autolink',
      'lists',
      'link',
      'image',
      'charmap',
      'anchor',
      'searchreplace',
      'visualblocks',
      'code',
      'fullscreen',
      'insertdatetime',
      'media',
      'table',
      'help',
      'wordcount',
      'autoresize',
    ],

    toolbar: 'bold underline strikethrough | forecolor backcolor | link image media | bullist numlist alignleft aligncenter alignright alignjustify | blocks fontfamily fontsize',

    block_formats: 'Paragraph=p;Heading 1=h1;Heading 2=h2;Heading 3=h3;',

    font_size_formats: '8px 9px 10px 11px 12px 14px 16px 18px 20px 22px 24px 26px 28px 36px 48px 72px',

    font_family_formats:
      '기본=돋움;' +
      '돋움=dotum,돋움;' +
      '굴림=gulim,굴림;' +
      '바탕=batang,바탕;' +
      '궁서=gungsuh,궁서;' +
      '맑은 고딕=malgun gothic,맑은 고딕;' +
      'Arial=arial,helvetica,verdana,sans-serif;' +
      'Andale Mono=andale mono,monospace;' +
      'Tahoma=tahoma,arial,helvetica,sans-serif;' +
      'Verdana=verdana,geneva,sans-serif',

    content_style:
      'body { font-family: 돋움, dotum, sans-serif; font-size: 14px; min-height: 600px !important; overflow: visible !important; } ' +
      'h3 { font-size: 16px !important; } ' +
      'html { overflow: visible !important; } ' +
      'img, video, iframe, embed, object { max-width: 100% !important; } ' +
      'video { height: auto !important; object-fit: contain !important; } ' +
      '.tox .tox-dialog__body .tox-form__group .tox-selectfield { display: none !important; } ' +
      '.tox .tox-dialog__body .tox-form__group .tox-label:contains("Open link in") { display: none !important; } ' +
      '.tox .tox-dialog__body .tox-form__group .tox-label:contains("링크 열기") { display: none !important; } ' +
      '.tox-throbber { z-index: 99999 !important; } ' +
      '.tox-throbber__busy-spinner { background-color: rgba(255, 255, 255, 0.85) !important; } ' +
      '.tox-dialog-loading-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(255, 255, 255, 0.85); z-index: 99999; display: none; } ' +
      '.tox-dialog-loading-overlay.show { display: flex; align-items: center; justify-content: center; } ' +
      '.tox-dialog-loading-spinner { color: #222f3e; font-size: 16px; position: relative; text-indent: -9999em; transform: translateZ(0); animation-delay: -0.16s; border-radius: 50%; width: 1em; height: 1em; animation-fill-mode: both; animation: bblFadInOut 1.8s infinite ease-in-out; } ' +
      ".tox-dialog-loading-spinner:before, .tox-dialog-loading-spinner:after { content: ''; position: absolute; top: 0; border-radius: 50%; width: 1em; height: 1em; animation-fill-mode: both; animation: bblFadInOut 1.8s infinite ease-in-out; } " +
      '.tox-dialog-loading-spinner:before { left: -1.5em; animation-delay: -0.32s; } ' +
      '.tox-dialog-loading-spinner:after { left: 1.5em; } ' +
      '@keyframes bblFadInOut { 0%, 80%, 100% { box-shadow: 0 1em 0 -0.3em } 40% { box-shadow: 0 1em 0 0 } } ' +
      '.tox-dialog__footer .tox-button:contains("저장") { display: none !important; } ' +
      '.tox-dialog__footer .tox-button:contains("Save") { display: none !important; } ' +
      '.tox-tinymce { min-height: 600px !important; } ' +
      '.tox-edit-area { min-height: 550px !important; overflow: visible !important; } ' +
      '.tox-edit-area__iframe { min-height: 550px !important; overflow: hidden !important; } ' +
      '.tox-editor-container { min-height: 550px !important; }',

    // Image settings
    image_advtab: false,
    image_dimensions: false,
    automatic_uploads: true,
    file_picker_types: 'image media',
    file_picker_callback: createFilePickerCallback(recaptchaVerify),
    images_upload_handler: createImagesUploadHandler(recaptchaVerify),

    // Media settings
    media_live_embeds: true,
    media_dimensions: false,
    media_alt_source: false,
    media_poster: false,

    // Valid elements for video
    extended_valid_elements: 'video[src|controls|width|height|autoplay|loop|muted|poster],source[src|type]',

    // Link settings
    default_link_target: '_blank',
    link_title: false,
    target_list: false,
    link_target_list: false,
    link_assume_external_targets: false,
    force_br_newlines: false,
    force_p_newlines: false,
    forced_root_block: 'p',

    // UI
    menubar: false,
    statusbar: false,
    resize: false,

    // Disable telemetry to avoid network errors
    telemetry: false,

    // Autoresize
    autoresize_bottom_margin: 12,
    autoresize_on_init: true,

    // Misc
    relative_urls: false,
    // Strip current host so resulting href is root-relative on mobile too
    remove_script_host: true,
    convert_urls: true,

    // Mobile optimizations
    mobile: {
      menubar: false,
      toolbar_mode: 'sliding',
      min_height: 600,
    },

    setup: function (editor) {
      // Load Korean i18n
      if (typeof tinymce !== 'undefined' && typeof tinymce.addI18n === 'function') {
        tinymce.addI18n('ko_KR', {
          "Redo": "다시 실행",
          "Undo": "실행 취소",
          "Cut": "잘라내기",
          "Copy": "복사",
          "Paste": "붙여넣기",
          "Select all": "전체 선택",
          "New document": "새 문서",
          "Ok": "확인",
          "Cancel": "취소",
          "Visual aids": "보이지 않는 요소 보기",
          "Bold": "굵게",
          "Italic": "기울임꼴",
          "Underline": "밑줄",
          "Strikethrough": "취소선",
          "Superscript": "위 첨자",
          "Subscript": "아래 첨자",
          "Clear formatting": "서식 지우기",
          "Remove": "제거",
          "Align left": "왼쪽 정렬",
          "Align center": "가운데 정렬",
          "Align right": "오른쪽 정렬",
          "No alignment": "정렬 안 함",
          "Justify": "양쪽 정렬",
          "Bullet list": "글머리 기호 목록",
          "Numbered list": "번호 매기기 목록",
          "Decrease indent": "들여쓰기 줄이기",
          "Increase indent": "들여쓰기 늘리기",
          "Close": "닫기",
          "Formats": "서식",
          "Your browser doesn't support direct access to the clipboard. Please use the Ctrl+X/C/V keyboard shortcuts instead.": "브라우저가 클립보드 접근을 지원하지 않습니다. Ctrl+X/C/V 키보드 단축키를 이용하세요.",
          "Headings": "Heading",
          "Heading 1": "Heading 1",
          "Heading 2": "Heading 2",
          "Heading 3": "Heading 3",
          "Heading 4": "Heading 4",
          "Heading 5": "Heading 5",
          "Heading 6": "Heading 6",
          "Blocks": "Paragraph",
          "Paragraph": "Paragraph",
          "Blockquote": "인용구",
          "Div": "Div",
          "Pre": "Pre",
          "Insert/edit image": "사진 첨부하기",
          "Insert/edit media": "비디오 삽입/수정",
          "Insert/edit link": "링크 삽입",
          "Image": "이미지",
          "Media": "미디어",
          "Link": "링크",
          "Source": "소스",
          "Source code": "소스 코드",
          "Insert video": "비디오 삽입",
          "Paste your embed code below:": "아래에 코드를 붙여넣으세요:",
          "Embed": "삽입",
          "Poster": "포스터",
          "Alternative source": "대체 소스",
          "Paste or type a link": "링크를 붙여넣거나 입력하세요",
          "General": "일반",
          "Advanced": "고급",
          "Width": "너비",
          "Height": "높이",
          "Dimensions": "크기",
          "Constrain proportions": "비율 유지",
          "Insert": "삽입",
          "Upload": "업로드",
          "Drop an image here": "여기에 이미지를 끌어다 놓으세요",
          "Browse for an image": "이미지 선택",
          "Alternative description": "대체 설명",
          "Save": "확인",
          "File": "파일",
          "Browse": "찾아보기",
          "Image description": "이미지 설명",
          "Image URL": "이미지 주소",
          "Image title": "이미지 제목",
          "Image list": "이미지 목록",
          "Image properties": "이미지 속성",
          "Remove image": "이미지 제거",
          "Edit image": "이미지 편집",
          "Replace image": "이미지 교체",
          "Upload failed": "업로드 실패",
          "Could not upload image": "이미지를 업로드할 수 없습니다",
          "Error": "오류",
          "Success": "성공",
          "Loading...": "로딩 중...",
          "Please wait...": "잠시 기다려 주세요...",
          "URL": "주소",
          "Text to display": "표시할 텍스트",
          "Open link in...": "링크 열기",
          "Current window": "현재 창",
          "New window": "새 창",
          "Target": "대상",
          "Title": "제목",
          "Rel": "관계",
          "Class": "클래스",
          "Link list": "링크 목록",
          "Link URL": "링크 주소",
          "Link text": "링크 텍스트",
          "Link title": "링크 제목",
          "Link target": "링크 대상",
          "Remove link": "링크 제거",
          "Edit link": "링크 편집",
          "Anchors": "앵커",
          "Anchor": "앵커",
          "Anchor name": "앵커 이름"
        });
      }
      const closeMenus = () => closeAllTinyMCEMenus()
      const forceClose = () => {
        closeAllTinyMCEMenus()
        const toolbarSelectors = ['.tox-toolbar', '.tox-toolbar__primary', '.tox-toolbar__overflow']
        toolbarSelectors.forEach((sel) => {
          document.querySelectorAll(sel).forEach((el) => {
            el.style.display = 'none'
            el.style.visibility = 'hidden'
          })
        })
        // Hide the entire TinyMCE container
        document.querySelectorAll('.tox-tinymce').forEach((el) => {
          el.style.display = 'none'
        })
      }

      editor.on('blur', closeMenus)
      editor.on('deactivate', closeMenus)
      editor.on('remove', forceClose)
      editor.on('keydown', (e) => {
        if (e.key === 'Escape') closeMenus()
      })
      // Hide toolbar immediately when form is submitted
      editor.on('BeforeSetContent', () => {
        const toolbar = editor.getContainer()?.querySelector('.tox-toolbar')
        if (toolbar) {
          toolbar.style.display = 'none'
        }
      })

      try {
        const form = editor.getElement() && editor.getElement().closest('form')
        if (form) {
          form.addEventListener(
            'submit',
            (e) => {
              forceClose()
            },
            { capture: true }
          )
        }
      } catch (e) {
        /* no-op */
      }

      editor.on('OpenWindow', function (e) {
        setTimeout(function () {
          const dialog = document.querySelector('.tox-dialog')
          if (!dialog) return

          const selectFields = dialog.querySelectorAll('.tox-selectfield')
          selectFields.forEach(function (field) {
            const formGroup = field.closest('.tox-form__group')
            if (formGroup) {
              formGroup.style.display = 'none'
            }
          })

          const saveButtons = dialog.querySelectorAll('.tox-button')
          saveButtons.forEach(function (button) {
            const buttonText = button.textContent || button.innerText
            if (buttonText === '저장' || buttonText === 'Save') {
              button.textContent = '확인'
              button.innerHTML = '확인'
            }
          })

          // Detect dialog type by checking dialog title or content
          const dialogTitle = dialog.querySelector('.tox-dialog__title')?.textContent || ''
          const isMediaDialog = dialogTitle.includes('비디오') || dialogTitle.includes('미디어') || dialogTitle.includes('Media') || dialogTitle.includes('Video')
          const isImageDialog = dialogTitle.includes('이미지') || dialogTitle.includes('사진') || dialogTitle.includes('Image')
          const isLinkDialog = dialogTitle.includes('링크') || dialogTitle.includes('Link')

          // Handle YouTube URL conversion ONLY in media dialog (insert video)
          if (isMediaDialog) {
            const urlInputs = dialog.querySelectorAll('input[type="url"], input[name="source"], input[name="src"], textarea[name="source"], textarea[name="src"]')
            urlInputs.forEach(function (input) {
              // Convert on input change (real-time conversion)
              input.addEventListener('input', function () {
                const url = this.value.trim()
                if (url && !url.startsWith('<iframe')) {
                  const iframeCode = convertYouTubeUrlToIframe(url)
                  if (iframeCode) {
                    // Update the input value with iframe code
                    this.value = iframeCode
                    // Store if it's Shorts
                    const tempCheck = document.createElement('div')
                    tempCheck.innerHTML = iframeCode
                    const iframeCheck = tempCheck.querySelector('iframe')
                    if (iframeCheck && iframeCheck.getAttribute('data-youtube-shorts') === 'true') {
                      this.setAttribute('data-is-shorts', 'true')
                    } else {
                      this.removeAttribute('data-is-shorts')
                    }
                  }
                }
              })

              // Handle input on blur (when user leaves the field)
              input.addEventListener('blur', function () {
                const url = this.value.trim()
                if (url && !url.startsWith('<iframe')) {
                  const iframeCode = convertYouTubeUrlToIframe(url)
                  if (iframeCode) {
                    // Update the input value with iframe code
                    this.value = iframeCode
                    // Store if it's Shorts
                    const tempCheck = document.createElement('div')
                    tempCheck.innerHTML = iframeCode
                    const iframeCheck = tempCheck.querySelector('iframe')
                    if (iframeCheck && iframeCheck.getAttribute('data-youtube-shorts') === 'true') {
                      this.setAttribute('data-is-shorts', 'true')
                    } else {
                      this.removeAttribute('data-is-shorts')
                    }
                  }
                }
              })

              // Handle form submission - ensure conversion happens before submit
              const form = input.closest('form') || dialog.querySelector('form')
              if (form) {
                form.addEventListener('submit', function (e) {
                  const url = input.value.trim()
                  if (url && !url.startsWith('<iframe')) {
                    const iframeCode = convertYouTubeUrlToIframe(url)
                    if (iframeCode) {
                      // Store the iframe code to preserve Shorts dimensions
                      input.value = iframeCode
                      // Also store in a data attribute for later reference
                      input.setAttribute('data-iframe-code', iframeCode)
                      // Store if it's Shorts
                      const tempCheck = document.createElement('div')
                      tempCheck.innerHTML = iframeCode
                      const iframeCheck = tempCheck.querySelector('iframe')
                      if (iframeCheck && iframeCheck.getAttribute('data-youtube-shorts') === 'true') {
                        input.setAttribute('data-is-shorts', 'true')
                      } else {
                        input.removeAttribute('data-is-shorts')
                      }
                    }
                  } else if (url.startsWith('<iframe')) {
                    // If already an iframe, preserve dimensions and attributes
                    // DO NOT override what user has set
                    const tempDiv = document.createElement('div')
                    tempDiv.innerHTML = url
                    const iframe = tempDiv.querySelector('iframe')
                    if (iframe) {
                      const dataShorts = iframe.getAttribute('data-youtube-shorts')
                      const dataType = iframe.getAttribute('data-youtube-type')
                      const width = iframe.getAttribute('width')
                      const height = iframe.getAttribute('height')

                      // If it's Shorts (by attribute or dimensions), preserve it
                      if (dataShorts === 'true' || dataType === 'shorts' || (width === '449' && height === '799')) {
                        iframe.setAttribute('data-youtube-shorts', 'true')
                        iframe.setAttribute('data-youtube-type', 'shorts')
                        // Preserve dimensions that user set
                        iframe.setAttribute('width', width || '449')
                        iframe.setAttribute('height', height || '799')
                        input.value = tempDiv.innerHTML
                      } else {
                        // Regular YouTube - preserve user's dimensions
                        iframe.setAttribute('data-youtube-shorts', 'false')
                        iframe.setAttribute('data-youtube-type', 'regular')
                        input.value = tempDiv.innerHTML
                      }
                    }
                  }
                }, true) // Use capture phase to run before TinyMCE's handler
              }

              // Handle button clicks as backup
              const submitButtons = dialog.querySelectorAll('.tox-button[type="submit"], .tox-button:not([type="button"]):not(.tox-button--secondary)')
              submitButtons.forEach(function (button) {
                if (button.textContent === '삽입' || button.textContent === 'Insert' || button.textContent === '확인' || button.textContent === 'Ok') {
                  button.addEventListener('click', function () {
                    const url = input.value.trim()
                    if (url && !url.startsWith('<iframe')) {
                      const iframeCode = convertYouTubeUrlToIframe(url)
                      if (iframeCode) {
                        input.value = iframeCode
                        input.setAttribute('data-iframe-code', iframeCode)
                      }
                    } else if (url.startsWith('<iframe')) {
                      // If already an iframe, preserve dimensions and attributes
                      // DO NOT override what user has set
                      const tempDiv = document.createElement('div')
                      tempDiv.innerHTML = url
                      const iframe = tempDiv.querySelector('iframe')
                      if (iframe) {
                        const dataShorts = iframe.getAttribute('data-youtube-shorts')
                        const dataType = iframe.getAttribute('data-youtube-type')
                        const width = iframe.getAttribute('width')
                        const height = iframe.getAttribute('height')

                        // If it's Shorts (by attribute or dimensions), preserve it
                        if (dataShorts === 'true' || dataType === 'shorts' || (width === '449' && height === '799')) {
                          iframe.setAttribute('data-youtube-shorts', 'true')
                          iframe.setAttribute('data-youtube-type', 'shorts')
                          // Preserve dimensions that user set
                          iframe.setAttribute('width', width || '449')
                          iframe.setAttribute('height', height || '799')
                          input.value = tempDiv.innerHTML
                        } else {
                          // Regular YouTube - preserve user's dimensions
                          iframe.setAttribute('data-youtube-shorts', 'false')
                          iframe.setAttribute('data-youtube-type', 'regular')
                          input.value = tempDiv.innerHTML
                        }
                      }
                    }
                  })
                }
              })
            })
          }

          // Reject YouTube URLs in image dialog
          if (isImageDialog) {
            const urlInputs = dialog.querySelectorAll('input[type="url"], input[name="source"], input[name="src"], textarea[name="source"], textarea[name="src"]')
            urlInputs.forEach(function (input) {
              // Check on blur
              input.addEventListener('blur', function () {
                const url = this.value.trim()
                if (url && convertYouTubeUrlToIframe(url)) {
                  alert('URL 이미지가 유효하지 않습니다. 올바른 이미지 URL(jpg, jpeg, png, gif, webp, svg) 또는 S3 URL을 입력해주세요.\n\n잘못된 URL: ' + url)
                  this.value = ''
                  this.focus()
                }
              })

              // Check on form submission
              const submitButtons = dialog.querySelectorAll('.tox-button[type="submit"], .tox-button:not([type="button"]):not(.tox-button--secondary)')
              submitButtons.forEach(function (button) {
                if (button.textContent === '삽입' || button.textContent === 'Insert' || button.textContent === '확인' || button.textContent === 'Ok') {
                  button.addEventListener('click', function (e) {
                    const url = input.value.trim()
                    if (url && convertYouTubeUrlToIframe(url)) {
                      e.preventDefault()
                      e.stopPropagation()
                      alert('URL 이미지가 유효하지 않습니다. 올바른 이미지 URL(jpg, jpeg, png, gif, webp, svg) 또는 S3 URL을 입력해주세요.\n\n잘못된 URL: ' + url)
                      input.value = ''
                      input.focus()
                      return false
                    }
                  }, { once: true })
                }
              })
            })
          }
        }, 100)

        setTimeout(function () {
          const dialog = document.querySelector('.tox-dialog')
          if (!dialog) return

          const saveButtons = dialog.querySelectorAll('.tox-button')
          saveButtons.forEach(function (button) {
            const buttonText = button.textContent || button.innerText
            if (buttonText === '저장' || buttonText === 'Save') {
              button.textContent = '확인'
              button.innerHTML = '확인'
            }
          })
        }, 500)

        const observer = new MutationObserver(function (mutations) {
          mutations.forEach(function (mutation) {
            if (mutation.type === 'childList') {
              mutation.addedNodes.forEach(function (node) {
                if (node.nodeType === 1) {
                  // Element node
                  const buttons = node.querySelectorAll ? node.querySelectorAll('.tox-button') : []
                  buttons.forEach(function (button) {
                    const buttonText = button.textContent || button.innerText
                    if (buttonText === '저장' || buttonText === 'Save') {
                      button.textContent = '확인'
                      button.innerHTML = '확인'
                    }
                  })

                  if (node.classList && node.classList.contains('tox-button')) {
                    const buttonText = node.textContent || node.innerText
                    if (buttonText === '저장' || buttonText === 'Save') {
                      node.textContent = '확인'
                      node.innerHTML = '확인'
                    }
                  }
                }
              })
            }
          })
        })

        observer.observe(document.body, {
          childList: true,
          subtree: true,
        })

        setTimeout(() => {
          observer.disconnect()
        }, 10000)
      })

      // Auto-resize images and videos to 80% of editor width
      editor.on('NodeChange', function (e) {
        const editorBody = editor.getBody()
        if (!editorBody) return

        const editorWidth = editorBody.clientWidth
        const maxWidth = Math.floor(editorWidth * 0.8)

        // Resize images
        const images = editorBody.querySelectorAll('img')
        images.forEach(function (img) {
          // Skip if already processed
          if (img.getAttribute('data-sized')) return

          // Wait for image to load to get natural dimensions
          if (img.complete) {
            if (img.naturalWidth > 0 && img.naturalHeight > 0) {
              img.setAttribute('width', maxWidth)
              const aspectRatio = img.naturalHeight / img.naturalWidth
              const newHeight = Math.floor(maxWidth * aspectRatio)
              img.setAttribute('height', newHeight)
            }
            img.setAttribute('data-sized', 'true')
          } else {
            img.onload = function () {
              if (img.naturalWidth > 0 && img.naturalHeight > 0) {
                img.setAttribute('width', maxWidth)
                const aspectRatio = img.naturalHeight / img.naturalWidth
                const newHeight = Math.floor(maxWidth * aspectRatio)
                img.setAttribute('height', newHeight)
              }
              img.setAttribute('data-sized', 'true')
            }
          }
        })

        // Resize embedded videos (iframes)
        const iframes = editorBody.querySelectorAll('iframe')
        iframes.forEach(function (iframe) {
          if (iframe.getAttribute('data-sized')) return

          const src = iframe.getAttribute('src') || ''
          const isYouTube = src.indexOf('youtube.com/embed/') !== -1 ||
            src.indexOf('youtube.com/watch') !== -1 ||
            src.indexOf('youtube.com/shorts/') !== -1 ||
            src.indexOf('youtu.be/') !== -1

          // Skip auto-resize for YouTube iframes - they already have correct dimensions
          // (Shorts: 449x799, Regular: 1278x719, or user-defined)
          // Also skip if user pasted iframe code directly
          if (isYouTube || iframe.getAttribute('data-user-pasted') === 'true') {
            iframe.setAttribute('data-sized', 'true')
            return
          }

          const originalWidth = parseInt(iframe.getAttribute('width')) || iframe.clientWidth || iframe.offsetWidth
          const originalHeight = parseInt(iframe.getAttribute('height')) || iframe.clientHeight || iframe.offsetHeight

          if (originalWidth > 0 && originalHeight > 0) {
            iframe.setAttribute('width', maxWidth)
            const aspectRatio = originalHeight / originalWidth
            const newHeight = Math.floor(maxWidth * aspectRatio)
            iframe.setAttribute('height', newHeight)
          }
          iframe.setAttribute('data-sized', 'true')
        })
      })

      // Validate image and video URLs when inserting content
      editor.on('BeforeSetContent', function (e) {
        if (!e.content) return

        // Store original content BEFORE any processing
        const originalContent = e.content
        let originalUrl = null // Store original URL if it's a YouTube URL

        // Check if input has data-is-shorts attribute (set by OpenWindow handler)
        const dialog = document.querySelector('.tox-dialog')
        let isShortsFromInput = false
        if (dialog) {
          const urlInputs = dialog.querySelectorAll('input[type="url"], input[name="source"], input[name="src"], textarea[name="source"], textarea[name="src"]')
          urlInputs.forEach(function (input) {
            if (input.getAttribute('data-is-shorts') === 'true') {
              isShortsFromInput = true
            }
          })
        }

        // Check if we're in image dialog context
        const isImageDialog = dialog && (
          dialog.querySelector('.tox-dialog__title')?.textContent?.includes('이미지') ||
          dialog.querySelector('.tox-dialog__title')?.textContent?.includes('사진') ||
          dialog.querySelector('.tox-dialog__title')?.textContent?.includes('Image')
        )
        const isMediaDialog = dialog && (
          dialog.querySelector('.tox-dialog__title')?.textContent?.includes('비디오') ||
          dialog.querySelector('.tox-dialog__title')?.textContent?.includes('미디어') ||
          dialog.querySelector('.tox-dialog__title')?.textContent?.includes('Media') ||
          dialog.querySelector('.tox-dialog__title')?.textContent?.includes('Video')
        )

        // Convert YouTube URLs to iframe BEFORE TinyMCE processes them (to prevent video tag conversion)
        if (isMediaDialog || !isImageDialog) {
          const trimmedContent = e.content.trim()
          // Check if content is a plain YouTube URL
          if (trimmedContent && !trimmedContent.startsWith('<')) {
            originalUrl = trimmedContent // Store original URL
            const iframeCode = convertYouTubeUrlToIframe(trimmedContent)
            if (iframeCode) {
              // Store the iframe code directly - TinyMCE will parse it
              e.content = iframeCode
            }
          }
        }

        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = e.content

        // Also check for YouTube URLs in video tags (in case TinyMCE already converted them)
        const videoTags = tempDiv.querySelectorAll('video, video source')
        videoTags.forEach(function (video) {
          const src = video.getAttribute('src') || video.getAttribute('poster')
          if (src) {
            const iframeCode = convertYouTubeUrlToIframe(src)
            if (iframeCode) {
              // Replace video tag with iframe
              const iframeDiv = document.createElement('div')
              iframeDiv.innerHTML = `<p>${iframeCode}</p>`
              video.parentNode.replaceChild(iframeDiv.firstChild, video)
            }
          }
        })

        // Check if content is a user-pasted iframe code (not from URL conversion)
        // Check both originalContent and current e.content to detect iframe paste
        const trimmedOriginal = originalContent.trim()
        const trimmedCurrent = e.content.trim()
        const isUserPastedIframe = (
          (trimmedOriginal.startsWith('<iframe') || trimmedCurrent.startsWith('<iframe')) &&
          !originalUrl &&
          !dialog // Not from dialog, means direct paste
        )

        // Preserve YouTube Shorts dimensions in existing iframes
        // Check by extracting video ID from src and checking original URL pattern
        const existingIframes = tempDiv.querySelectorAll('iframe[src*="youtube.com/embed"]')
        existingIframes.forEach(function (iframe) {
          const src = iframe.getAttribute('src') || ''
          const videoIdMatch = src.match(/\/embed\/([a-zA-Z0-9_-]{11})/)
          if (!videoIdMatch || !videoIdMatch[1]) return

          const videoId = videoIdMatch[1]
          const dataShorts = iframe.getAttribute('data-youtube-shorts')
          const dataType = iframe.getAttribute('data-youtube-type')
          const currentWidth = parseInt(iframe.getAttribute('width')) || 0
          const currentHeight = parseInt(iframe.getAttribute('height')) || 0

          // If user pasted iframe code directly, preserve original dimensions
          // Check if originalContent contains width/height attributes
          // Extract width/height from originalContent to detect custom dimensions
          const widthMatchOriginal = trimmedOriginal.match(/width\s*=\s*["']?(\d+)["']?/i)
          const heightMatchOriginal = trimmedOriginal.match(/height\s*=\s*["']?(\d+)["']?/i)
          const hasCustomDimensions = widthMatchOriginal && heightMatchOriginal &&
            widthMatchOriginal[1] && heightMatchOriginal[1] &&
            // Not default values: 1278x719, 449x799, 560x314
            !(widthMatchOriginal[1] === '1278' && heightMatchOriginal[1] === '719') &&
            !(widthMatchOriginal[1] === '449' && heightMatchOriginal[1] === '799') &&
            !(widthMatchOriginal[1] === '560' && heightMatchOriginal[1] === '314')

          if (isUserPastedIframe || hasCustomDimensions) {
            // Mark this iframe as user-pasted to prevent SetContent from overriding
            iframe.setAttribute('data-user-pasted', 'true')

            // Extract and preserve original width/height from originalContent if available
            // Use the matches we already found above, or try again
            const widthMatch = widthMatchOriginal || trimmedOriginal.match(/width\s*=\s*["']?(\d+)["']?/i)
            const heightMatch = heightMatchOriginal || trimmedOriginal.match(/height\s*=\s*["']?(\d+)["']?/i)

            if (widthMatch && heightMatch && widthMatch[1] && heightMatch[1]) {
              const originalWidth = widthMatch[1]
              const originalHeight = heightMatch[1]
              // Always set to preserve user's original values
              iframe.setAttribute('width', originalWidth)
              iframe.setAttribute('height', originalHeight)
            }

            // Keep original width and height as-is
            // Only set data attributes if not already set
            if (!dataShorts && !dataType) {
              // Try to detect if it's Shorts based on dimensions
              const finalWidth = parseInt(iframe.getAttribute('width')) || currentWidth
              const finalHeight = parseInt(iframe.getAttribute('height')) || currentHeight
              if (finalWidth === 449 && finalHeight === 799) {
                iframe.setAttribute('data-youtube-shorts', 'true')
                iframe.setAttribute('data-youtube-type', 'shorts')
              } else {
                iframe.setAttribute('data-youtube-shorts', 'false')
                iframe.setAttribute('data-youtube-type', 'regular')
              }
            }
            // Don't modify width/height further - keep user's original values
            return
          }

          // Check original URL or content to see if it was a Shorts URL
          // Check both originalUrl (before convert) and originalContent (might be iframe code)
          // Also check if originalContent contains Shorts indicators BEFORE TinyMCE parsed it
          const isShortsUrl = (originalUrl && originalUrl.indexOf('/shorts/') !== -1) ||
            originalContent.indexOf('/shorts/') !== -1 ||
            originalContent.indexOf('data-youtube-shorts="true"') !== -1 ||
            originalContent.indexOf("data-youtube-shorts='true'") !== -1 ||
            originalContent.indexOf('data-youtube-shorts=true') !== -1 ||
            originalContent.indexOf('data-youtube-type="shorts"') !== -1 ||
            originalContent.indexOf("data-youtube-type='shorts'") !== -1 ||
            originalContent.indexOf('data-youtube-type=shorts') !== -1 ||
            originalContent.indexOf('width="449"') !== -1 ||
            originalContent.indexOf("width='449'") !== -1 ||
            originalContent.indexOf(' width="449"') !== -1 ||
            originalContent.indexOf(" width='449'") !== -1 ||
            originalContent.indexOf('height="799"') !== -1 ||
            originalContent.indexOf("height='799'") !== -1

          // Check if it's Shorts - prioritize input data attribute, then original URL, then attributes, then dimensions
          const isShorts = isShortsFromInput ||
            isShortsUrl ||
            dataShorts === 'true' ||
            dataShorts === true ||
            dataType === 'shorts' ||
            (currentWidth === 449 && currentHeight === 799)

          if (isShorts) {
            // Preserve Shorts dimensions - ALWAYS set to 449x799
            iframe.setAttribute('width', '449')
            iframe.setAttribute('height', '799')
            iframe.setAttribute('data-youtube-shorts', 'true')
            iframe.setAttribute('data-youtube-type', 'shorts')
          } else if (src.indexOf('youtube.com/embed/') !== -1) {
            // Regular YouTube - only fix if it's clearly wrong (TinyMCE default) AND not Shorts
            // BUT if dimensions are 449x799, it might be Shorts that was mis-detected
            // IMPORTANT: Skip if this iframe has data-user-pasted (already handled above)
            if (iframe.getAttribute('data-user-pasted') === 'true') {
              return // Already handled, skip
            }

            if (currentWidth === 449 && currentHeight === 799) {
              // This looks like Shorts - preserve it
              iframe.setAttribute('width', '449')
              iframe.setAttribute('height', '799')
              iframe.setAttribute('data-youtube-shorts', 'true')
              iframe.setAttribute('data-youtube-type', 'shorts')
            } else if (currentWidth === 560 && currentHeight === 314) {
              // TinyMCE default - fix to regular YouTube
              iframe.setAttribute('width', '1278')
              iframe.setAttribute('height', '719')
              iframe.setAttribute('data-youtube-shorts', 'false')
              iframe.setAttribute('data-youtube-type', 'regular')
            }
            // DO NOT auto-fix other dimensions - preserve what user set
          }
        })

        // Update e.content with modified HTML
        // Make sure data-user-pasted is preserved in the final content
        e.content = tempDiv.innerHTML

        // Validate images - only reject YouTube URLs if we're in image dialog
        const images = tempDiv.querySelectorAll('img')
        for (let i = 0; i < images.length; i++) {
          const img = images[i]
          const src = img.getAttribute('src')
          if (src && !src.startsWith('data:')) {
            // Validate image URL format - treat YouTube URLs as invalid images
            if (!isValidImageUrl(src)) {
              e.preventDefault()
              alert(
                'URL 이미지가 유효하지 않습니다. 올바른 이미지 URL(jpg, jpeg, png, gif, webp, svg) 또는 S3 URL을 입력해주세요.\n\n잘못된 URL: ' +
                src
              )

              // Focus back to the URL input if dialog is open
              setTimeout(() => {
                const dialog = document.querySelector('.tox-dialog')
                if (dialog) {
                  const urlInput = dialog.querySelector('input[type="url"], input[name="src"]')
                  if (urlInput) {
                    urlInput.focus()
                    urlInput.select()
                  }
                }
              }, 100)
              return false
            }
          }
        }

        // Validate videos - allow YouTube URLs (they will be converted to iframe)
        const videos = tempDiv.querySelectorAll('video, video source')
        for (let i = 0; i < videos.length; i++) {
          const video = videos[i]
          const src = video.getAttribute('src')
          if (src && !src.startsWith('data:')) {
            // Skip validation for YouTube URLs - they will be converted to iframe in media dialog
            if (convertYouTubeUrlToIframe(src)) {
              continue // Allow YouTube URLs, they'll be handled by media dialog conversion
            }

            // Validate other video URLs
            if (!isValidVideoUrl(src)) {
              e.preventDefault()
              alert(
                'URL 비디오가 유효하지 않습니다. 올바른 비디오 URL(mp4, webm, ogg, mov 등) 또는 S3 URL을 입력해주세요.\n\n잘못된 URL: ' +
                src
              )

              // Focus back to the URL input if dialog is open
              setTimeout(() => {
                const dialog = document.querySelector('.tox-dialog')
                if (dialog) {
                  const urlInput = dialog.querySelector('input[type="url"], input[name="src"]')
                  if (urlInput) {
                    urlInput.focus()
                    urlInput.select()
                  }
                }
              }, 100)
              return false
            }
          }
        }

        // Validate iframe embeds (for media)
        const iframes = tempDiv.querySelectorAll('iframe')
        for (let i = 0; i < iframes.length; i++) {
          const iframe = iframes[i]
          const src = iframe.getAttribute('src')
          if (src && !src.startsWith('data:') && !isValidUrl(src)) {
            e.preventDefault()
            alert('URL 미디어가 유효하지 않습니다. 올바른 URL을 입력해주세요.\n\n잘못된 URL: ' + src)

            // Focus back to the URL input if dialog is open
            setTimeout(() => {
              const dialog = document.querySelector('.tox-dialog')
              if (dialog) {
                const urlInput = dialog.querySelector('input[type="url"], input[name="src"]')
                if (urlInput) {
                  urlInput.focus()
                  urlInput.select()
                }
              }
            }, 100)
            return false
          }
        }
      })

      editor.on('SetContent', function () {
        const links = editor.getBody().querySelectorAll('a')
        links.forEach(function (link) {
          if (!link.getAttribute('target')) {
            link.setAttribute('target', '_blank')
          }
        })

        // Fix YouTube iframe dimensions after content is set
        setTimeout(function () {
          const editorBody = editor.getBody()
          if (!editorBody) return

          const editorWidth = editorBody.clientWidth || 800

          const iframes = editorBody.querySelectorAll('iframe[src*="youtube.com/embed"]')
          iframes.forEach(function (iframe) {
            // Skip if this is a user-pasted iframe - preserve original dimensions
            const isUserPasted = iframe.getAttribute('data-user-pasted') === 'true'
            if (isUserPasted) {
              // Remove inline styles that might have been set by other logic
              // For user-pasted iframes, we should calculate inline styles based on their actual dimensions
              // if they exceed editor width, otherwise remove inline styles
              const actualWidth = parseInt(iframe.getAttribute('width')) || 0
              const actualHeight = parseInt(iframe.getAttribute('height')) || 0

              if (actualWidth > 0 && actualHeight > 0) {
                // Only set inline styles if actual width exceeds editor width
                if (actualWidth > editorWidth) {
                  const aspectRatio = actualHeight / actualWidth
                  const newWidth = editorWidth
                  const newHeight = Math.floor(newWidth * aspectRatio)
                  iframe.style.width = newWidth + 'px'
                  iframe.style.height = newHeight + 'px'
                } else {
                  // Remove inline styles if not needed
                  iframe.style.width = ''
                  iframe.style.height = ''
                }
              } else {
                // Fallback: remove inline styles
                iframe.style.width = ''
                iframe.style.height = ''
              }
              return // Skip all other processing for user-pasted iframes
            }

            const src = iframe.getAttribute('src') || ''
            const dataShorts = iframe.getAttribute('data-youtube-shorts')
            const dataType = iframe.getAttribute('data-youtube-type')
            const widthAttr = iframe.getAttribute('width')
            const heightAttr = iframe.getAttribute('height')
            // Check both attribute and dimensions to determine if it's Shorts
            const isShorts = dataShorts === 'true' ||
              dataShorts === true ||
              dataType === 'shorts' ||
              (widthAttr === '449' && heightAttr === '799')

            const currentWidth = parseInt(widthAttr) || 0
            const currentHeight = parseInt(heightAttr) || 0

            // Fix dimensions based on type - DO NOT override Shorts
            if (isShorts) {
              // Shorts: 449x799 - ALWAYS preserve these dimensions
              iframe.setAttribute('width', '449')
              iframe.setAttribute('height', '799')
              iframe.setAttribute('data-youtube-shorts', 'true')
              iframe.setAttribute('data-youtube-type', 'shorts')
            } else {
              // Regular YouTube video: Check if it has custom dimensions (user-pasted)
              // If dimensions are not default (1278x719, 449x799, 560x314), use actual dimensions
              const isCustomSize = currentWidth > 0 && currentHeight > 0 &&
                !(currentWidth === 1278 && currentHeight === 719) &&
                !(currentWidth === 449 && currentHeight === 799) &&
                !(currentWidth === 560 && currentHeight === 314)

              if (isCustomSize) {
                // User-pasted iframe with custom dimensions - use actual dimensions for aspect ratio
                const aspectRatio = currentHeight / currentWidth

                // Only resize if actual width exceeds editor width
                if (currentWidth > editorWidth) {
                  const newWidth = editorWidth
                  const newHeight = Math.floor(newWidth * aspectRatio)
                  iframe.style.width = newWidth + 'px'
                  iframe.style.height = newHeight + 'px'
                } else {
                  // Remove inline styles if not needed
                  iframe.style.width = ''
                  iframe.style.height = ''
                }

                // Mark as user-pasted to prevent future overrides
                iframe.setAttribute('data-user-pasted', 'true')
              } else {
                // Default regular YouTube video: Calculate responsive size while maintaining aspect ratio
                // Original dimensions: 1278x719, aspect ratio = 719/1278 ≈ 0.5626
                const originalWidth = 1278
                const originalHeight = 719
                const aspectRatio = originalHeight / originalWidth

                // Only resize if original width exceeds editor width
                if (originalWidth > editorWidth) {
                  // Calculate new dimensions based on 100% editor width while maintaining aspect ratio
                  const newWidth = editorWidth
                  const newHeight = Math.floor(newWidth * aspectRatio)

                  // Set inline style only - keep original width/height attributes unchanged
                  iframe.style.width = newWidth + 'px'
                  iframe.style.height = newHeight + 'px'
                } else {
                  // Remove inline styles if not needed
                  iframe.style.width = ''
                  iframe.style.height = ''
                }
              }

              // Keep original attributes unchanged, only set data attributes
              iframe.setAttribute('data-youtube-shorts', 'false')
              iframe.setAttribute('data-youtube-type', 'regular')
            }
          })
        }, 50)
      })

      editor.on('ExecCommand', function (e) {
        if (e.command === 'mceInsertLink' || e.command === 'mceUpdateLink' || e.command === 'mceEditLink') {
          setTimeout(function () {
            const links = editor.getBody().querySelectorAll('a')
            links.forEach(function (link) {
              if (!link.getAttribute('target')) {
                link.setAttribute('target', '_blank')
              }
            })
          }, 100)
        }

        // Handle media insertion - convert YouTube URLs to iframe
        if (e.command === 'mceInsertMedia' && e.value && e.value.source) {
          const sourceUrl = e.value.source
          // Check if it's already an iframe code
          if (sourceUrl.trim().startsWith('<iframe')) {
            // Parse and preserve Shorts dimensions
            const tempDiv = document.createElement('div')
            tempDiv.innerHTML = sourceUrl.trim()
            const iframe = tempDiv.querySelector('iframe')
            if (iframe) {
              const width = iframe.getAttribute('width')
              const height = iframe.getAttribute('height')
              const dataShorts = iframe.getAttribute('data-youtube-shorts')
              const dataType = iframe.getAttribute('data-youtube-type')

              // If it's Shorts, ensure correct dimensions
              if (dataShorts === 'true' || dataType === 'shorts' || (width === '449' && height === '799')) {
                iframe.setAttribute('width', '449')
                iframe.setAttribute('height', '799')
                iframe.setAttribute('data-youtube-shorts', 'true')
                iframe.setAttribute('data-youtube-type', 'shorts')
                e.value.source = tempDiv.innerHTML
              }
            }
          } else {
            // Convert URL to iframe
            const iframeCode = convertYouTubeUrlToIframe(sourceUrl)
            if (iframeCode) {
              // Replace the source with iframe code
              e.value.source = iframeCode
              // Insert the iframe directly
              setTimeout(function () {
                editor.insertContent(`<p>${iframeCode}</p>`)
              }, 100)
              e.preventDefault()
              return false
            }
          }
        }
      })

      // Additional event to ensure target="_blank" is preserved
      editor.on('NodeChange', function (e) {
        const links = editor.getBody().querySelectorAll('a')
        links.forEach(function (link) {
          if (!link.getAttribute('target')) {
            link.setAttribute('target', '_blank')
          }
        })
      })
    },
  }
}